import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { SessionModalComponent } from 'src/app/shared/components/session-modal/session-modal.component';
import {
  ILineaNegocio,
  IProducto,
  IScreenDim,
} from 'src/app/shared/Entities/entities';
import { paths, productosPath } from 'src/app/shared/helpers/constants';
import { AuthService } from 'src/app/shared/services/auth.service';
import { EventsService } from 'src/app/shared/services/events.service';
import { SessionTimeoutService } from 'src/app/shared/services/session-timeout.service';
import { IMenu, IMenuItem } from './../../shared/Entities/entities';
import { CommonService } from 'src/app/shared/services/common.service';
import { menuWidth } from 'src/app/shared/helpers/constants';
import { ProductoIndividualService } from 'src/app/shared/services/producto-individual.service';
@Component({
  selector: 'app-log-out',
  templateUrl: './log-out.component.html',
  styleUrls: ['./log-out.component.sass'],
})
export class LogOutComponent implements OnInit, OnDestroy {
  username = '';
  rut = '';
  isLoggedIn$: Observable<boolean>;
  @Input() segurosIndivuales: IProducto[] = [];
  @Input() segurosColectivos: IProducto[] = [];
  @Input() segurosVitalicios: IProducto[] = [];
  @Input() segurosPrivados: IProducto[] = [];
  // optionSafe = '';
  opened = true;
  showInfome = false;
  over = '';
  menuWidth = menuWidth;
  @Output() public sidenavToggle = new EventEmitter();
  // @Input() ngForTrackBy: TrackByFunction<T>;

  /* mainMenu: IMenu = { title: 'MIS PRODUCTOS', route: productosPath, items: [] }; */
  mainMenu: IMenu = { title: '', route: { path: '' }, items: [] };
  private subscriptions: Subscription[] = [];

  private _timerSubscription: Subscription;
  visibilityPagarProductos = false;
  lifemax = true;
  private screenDim$: Observable<IScreenDim>;
  constructor(
    public router: Router,
    private auth: AuthService,
    private eventsSrv: EventsService,
    private route: ActivatedRoute,
    private idleTimeoutSvc: SessionTimeoutService,
    public dialog: MatDialog,
    private commonSvc: CommonService
  ) {
    this.over = 'side';

    this.screenDim$ = this.commonSvc.screenDim$;
    this.screenDim$.subscribe(res => {
      if (res.width < this.menuWidth) {
        this.opened = false;
        this.over = 'over';
      } else {
        this.opened = true;
        this.over = 'side';
      }
    });

    /* breakpointObserver.observe(['(max-width: 860px)']).subscribe(result => {
      if (result.matches) {
        this.opened = false;
        this.over = 'over';
      } else {
        this.opened = true;
        this.over = 'side';
      }
    }); */

    this.isLoggedIn$ = this.auth.isLoggedInBehavior;
    this.isLoggedIn$.subscribe(islogged => {
      if (!islogged) {
        window.location.replace('');
      } else {
        this.auth.CerrarSesion();
        // this.Navigate.ngOnDestroy();
        this.auth.logout();
        this.auth.logoutRedirect();
      }
    });

    this.router.routeReuseStrategy.shouldReuseRoute = () => {
      return false;
    };
    // subscribe to home component messages
    const routeSubscription = this.eventsSrv.routeLifeMax$.subscribe(
      lifemax => {
        this.lifemax = lifemax;
      }
    );

    this.subscriptions.push(routeSubscription);

    const pagarSubscription = this.eventsSrv.visibilityPagarProductos$.subscribe(
      visibilityPagarProductos => {
        this.visibilityPagarProductos = visibilityPagarProductos;
      }
    );

    this.subscriptions.push(pagarSubscription);

    const informeSubscription = this.eventsSrv.visibilityInformeRentabilidad$.subscribe(
      showInfome => {
        this.showInfome = showInfome;
      }
    );

    this.subscriptions.push(informeSubscription);
  }

  trackByFn(index: any, item: any) {
    return index;
  }

  public startCounter() {
    if (this._timerSubscription) {
      this._timerSubscription.unsubscribe();
    }
  }

  public resetSessionTimer() {
    this.startCounter();
    // this._status = 'Initialized.';
    this.idleTimeoutSvc.resetTimer();
  }

  ngOnInit() {
    this.startCounter();
    const _idleTimerSubscription = this.idleTimeoutSvc.timeoutExpired.subscribe(
      res => {
        if (res) {
          this.logout();
        } else {
          this.idleTimeoutSvc.setLogout(true);
          const dialogRef = this.dialog.open(SessionModalComponent, {
            width: '290px',
            height: '180px',
            disableClose: true,
            closeOnNavigation: true,
          });

          dialogRef.afterClosed().subscribe(result => {
            if (result) {
              this.auth.refresh(result);
            }
          });
        }
      }
    );
    this.subscriptions.push(_idleTimerSubscription);
    const menuSubscription = this.eventsSrv.menuChange$.subscribe(() => {
      this.mainMenu = this.eventsSrv.getMenu();
    });
    this.subscriptions.push(menuSubscription);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  onToggleSidenav() {
    this.sidenavToggle.emit();
    this.opened = this.opened ? !this.opened : true;
  }

  getProducts(data: ILineaNegocio[], lineaNegocio: string) {
    const lista = data.find(d => d.LineaNegocio === lineaNegocio);
    if (!lista) {
      return [];
    }

    return lista.ListaProductos.Producto;
  }

  navigateTo(menu: IMenuItem, item: IMenuItem) {
    menu.children.forEach(i => {
      i.active = false;
    });
    item.active = true;

    this.router.navigate(
      [
        `/${menu.route.rootPath}/${menu.route.path}/${
          item.route.path.split('/')[0]
        }`,
        item.id ? item.id : null,
      ],
      {
        queryParams: item.route.params ? item.route.params : null,
        relativeTo: this.route,
      }
    );
  }

  lostFocus(event: any, item: IMenuItem) {
    /* const elements = document.getElementsByTagName(
      'mat-expansion-panel-header'
    );
    for (let i = 0; i < elements.length; i++) {
      (elements[i] as HTMLElement).blur();
    } */
    // if (!item.active) {

    const menu = this.eventsSrv.getMenu();
    menu.items.forEach(x =>
      x.route.label !== item.route.label
        ? (x.active = false)
        : x.children.forEach(c => (c.active = false))
    );

    menu.items.find(
      x => x.route.label === item.route.label
    ).active = !item.active;
    this.router.navigate([`${item.route.rootPath}/${item.route.path}`]);
    // }
  }

  logout() {
    this.auth.logoutRedirect();
    /*
    this.auth.logout().subscribe(data => {
      this.router.navigate([paths.root.path]);
    });
    */
  }

  misDatos() {
    this.router.navigate([`/${productosPath.path}/${paths.misDatos.path}`]);
  }

  cambiarContrasena() {
    this.router.navigate([
      `/${productosPath.path}/${paths.cambiarContrasena.path}`,
    ]);
  }
  pagarProductos() {
    this.router.navigate([
      `/${productosPath.path}/${paths.pagarProductos.path}`,
    ]);
  }

  goInformeRentabilidad() {
    this.router.navigate([
      `/${productosPath.path}/${paths.informeRentabilidad.path}`,
    ]);
  }

  verifyRoute() {
    return !(
      this.router.url.indexOf(paths.claveTemporal.path) >= 0 ||
      this.router.url.indexOf(paths.firmaElectronica.path) >= 0
    );
  }
}
